import type * as NodeType from './NodeType';
import JSXClosingBase from './shared/JSXClosingBase';

export default class JSXClosingFragment extends JSXClosingBase {
	declare type: NodeType.tJSXClosingFragment;
}
